module.exports = __webpack_public_path__ + "static/media/civil4.ff85627b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/civil4.jpg
// module id = 5778
// module chunks = 0